export const buildPermission = (action, resource, scope) => {
  return scope ? `${action}:${resource}:${scope}` : `${action}:${resource}`;
};

export const can = (permissions = [], action, resource, scope) => {
  if (!permissions.length) return false;

  return permissions.some((perm) => {
    const [permAction, permResource, permScope] = perm.split(":");

    if (permAction !== action || permResource !== resource) {
      return false;
    }

    // 🔥 CASO ESPECIAL: cabin:region
    if (action === "cabin" && resource === "region") {
      if (scope) {
        // SOLO wildcard permite seleccionar región
        return permScope === "*";
      }
      // acceso básico (tener o no scope)
      return true;
    }

    // ✅ COMPORTAMIENTO NORMAL (users, etc.)
    if (permScope === "*") return true;

    if (!scope) return true;

    return permScope === scope;
  });
};
